import { TreatmentTarget } from "../treatments/treatment_target";

export class PauseTreatment extends TreatmentTarget {
  constructor() {
    super();
  }

  getData() {
    return this.querySelector('.pause_input').value;
  }

  getIcon() {
    return 'fa-pause-circle'
  }

  isTarget() {
    return false;
  }

  static getType() {
    return "PAUSE"
  }

  connectedCallback() {
    this.innerHTML =
      `
      <div class="col-sm-12 ct_action" data-action_type=PAUSE>
        <div class="panel panel-default">
            <h4>Add Pause</h4><a class="remove"><i class="fa fa-times" aria-hidden="true"></i></a>
            <div class="form-group">
              <select class="form-control pause_input">
                <option value="5">5 Seconds</option>
                <option value="10">10 Seconds</option>
                <option value="15">15 Seconds</option>
              </select>
            </div>
        </div>
      </div>
      <div class="col-sm-12 ct_line">
        <div class="ct_vertical_arrow"></div>
        <div class="option_text">Waiting until next action</div>
        <div class="ct_vertical_arrow">
          <div class=arrow-down></div>
        </div>
      </div>
      `;
    super.connectedCallback();
  }
}

customElements.define('pause-treatment', PauseTreatment)